<template>
	<label
		class="flex items-center gap-2"
		:class="props.leftToggle ? 'flex-row-reverse' : 'flex-row'"
	>
		<span
			class="text-xs font-semibold text-slate-950"
			:class="props.capitalize ? 'capitalize' : 'uppercase'"
		>
			{{ label }}
		</span>

		<div class="relative h-5 w-9 cursor-pointer">
			<!-- Hidden checkbox (still accessible to screen readers & keyboard) -->
			<input
				type="checkbox"
				class="peer sr-only"
				:checked="modelValue"
				@change="
					$emit(
						'update:modelValue',
						($event.target as HTMLInputElement)?.checked ?? false
					)
				"
			/>

			<!-- Toggle track -->
			<div
				class="peer-checked:bg-accent-400 bg-secondary-300 h-full w-full rounded-full transition-colors duration-300"
			></div>

			<!-- Toggle thumb (the white circle) -->
			<div
				class="peer-checked:border-accent-400 absolute top-0 left-0 h-5 w-5 rounded-full border-2 border-slate-300 bg-white transition-all duration-300 peer-checked:translate-x-4"
			></div>
		</div>
	</label>
</template>

<script setup lang="ts">
const props = defineProps<{
	modelValue: boolean
	label: string
	leftToggle?: boolean
	capitalize?: boolean
}>()

defineEmits(['update:modelValue'])
</script>
